import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ConfirmDialog from '../../Global/Modals/ConfirmDialog';
import { withNamespaces } from 'react-i18next';

export class RateInvalid extends PureComponent {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
  };

  render() {
    const { open, onConfirm, onClose, t } = this.props;
    return (
      <ConfirmDialog
        open={open}
        onConfirm={onConfirm}
        onClose={onClose}
        confirmLabel={t('Continue')}
        title={t('Rates Are Potentially Invalid')}
        message={t(
          'Changes made to this shipment may have invalidated the current rates. Click continue to proceed or cancel to return to the shipment to refresh rates.'
        )}
      />
    );
  }
}

export default withNamespaces()(RateInvalid);
